<section>
  <div class="loading loading-anim">
    LOADING
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </div>
</section>
